import React from "react";
import bodyHelperTypes from "../../../utils/BodyHelperTypes";
import DocumentsDropdown from "../../../components/DocumentsDropdown";

const sIACSummaries_Content = [
    // {
    //     format: bodyHelperTypes.title,
    //     order: 10,
    //     content: "SIAC Newsletter"
    // },
    // {
    //     format: bodyHelperTypes.paragraphs,
    //     order: 20,
    //     content: [

    //         "The Outreach & Promotion Standing Committee created and disseminates a quarterly SIAC Newsletter. Select a date from the dropdown list to view newsletter first released September 2021.",

    //         <><DocumentsDropdown typeId="21" /><br/></>
    //     ]
    // },
    {
        format: bodyHelperTypes.title,
        order: 10,
        content: <>SIAC Meeting Summaries
            <br />
            <br />
        </>
    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 20,
        content: [
            <>
                {/* <b>Council Meeting Summaries</b> <br/><br/> */}
                Select a meeting date from the dropdown list below to view the summary.</>,
            <><DocumentsDropdown typeID="2" /><br /></>
        ]
    },
    // {
    //     format: bodyHelperTypes.paragraphs,
    //     order: 50,
    //     content: [
    //     <><b>Handouts</b> <br/><br/>
    //     Select a meeting date from the dropdown list below to view handouts for any meeting held from June 2015 forward.</>,
    //     <><DocumentsDropdown typeId="16" /><br/></>
    //     ]
    // },
    {
        format: bodyHelperTypes.title,
        order: 21,
        content: "SIAC Workgroups Summaries"
    },
    // {
    //     format: bodyHelperTypes.title,
    //     order: 30,
    //     content: "SIAC Standing Committee Meeting Summaries"
    // },
    {
        format: bodyHelperTypes.paragraphs,
        order: 40,
        content: [
            <>
                {/* <b>Standing Committee Meeting Summaries</b> <br/><br/> */}
                Select a meeting date from the dropdown list below to view.</>,
            <><DocumentsDropdown typeID="17" /><br /></>
        ]
    },
    // {
    //     format: bodyHelperTypes.title,
    //     order: 50,
    //     content: "Kentucky Rapid Response and Stabilization Services (KRRSS)"
    // },
    {
        format: bodyHelperTypes.paragraphs,
        order: 60,
        content: [

            <div className="ms-3">

            <strong>Kentucky Rapid Response and Stabilization Services (KRRSS)</strong><br/><br/>

                {/* <b>Standing Committee Meeting Summaries</b> <br/><br/> */}
                {/* Select a meeting date from the dropdown list below to view.</>, */}
                <DocumentsDropdown typeID="26" /><br />


            </div>

        ]
    },
    // {
    //     format: bodyHelperTypes.title,
    //     order: 70,
    //     content: "Service Engagement & Retention (SER)"
    // },
    {
        format: bodyHelperTypes.paragraphs,
        order: 80,
        content: [

            <div className="ms-3">

            <strong>Service Engagement & Retention (SER)</strong><br/><br/>

            <DocumentsDropdown typeID="27" /><br />


            </div>
           
               
                
            
        ]
    },
    // {
    //     format: bodyHelperTypes.title,
    //     order: 90,
    //     content: "Standardized Screening and Assessment (SSA)"
    // },
    {
        format: bodyHelperTypes.paragraphs,
        order: 100,
        content: [



            <div className="ms-3">

            <strong>Standardized Screening and Assessment (SSA)</strong><br/><br/>

            <DocumentsDropdown typeID="28" /><br />


            </div>
            
        ]
    },
    // {
    //     format: bodyHelperTypes.title,
    //     order: 110,
    //     content: "Workgroup Quarterly Reports"
    // },
    {
        format: bodyHelperTypes.paragraphs,
        order: 120,
        content: [


            <div className="ms-3">

            <strong>Workgroup Quarterly Reports</strong><br/><br/>

            <DocumentsDropdown typeID="29" /><br />


            </div>
         
        ]
    },








    // {
    //     format: bodyHelperTypes.paragraphs,
    //     order: 70,
    //     content: [
    //     <><b>Social and Emotional Health Task Force Meeting Summaries</b> <br/><br/>
    //     Select a meeting date from the dropdown list below to view summaries of meetings held by this task force.</>,
    //     <><DocumentsDropdown typeID="20" /><br/></>
    //     ]
    // },









];

export default sIACSummaries_Content;